import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  status: "all",
  text: "",
};

const filterSlice = createSlice({
  name: "filter",
  initialState,
  reducers: {
    filterByFeatured: (state, action) => {
      state.status = action.payload;
    },
    filterBySearch: (state, action) => {
      state.text = action.payload;
    },
  },
});

export default filterSlice.reducer;
export const { filterByFeatured, filterBySearch } = filterSlice.actions;
